<script>
import SetupProfile from './SetupProfile.vue'
import MultiSelect from '@/components/registration/MultiSelect.vue'

import { mapGetters } from 'vuex'
export default {
    // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        MultiSelect,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: SetupProfile, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            section: 'account-info',
            configData: {},
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    created() {
        this.configData = this.$store.state.registration.configData
    },
    async mounted() {
        // if (this.configData.riskFactor == false ) {
        //     if (this.configData.additionalInfo == false ) {
        //     this.$router.push({name: 'self-registration-preview'})
        //    }else{
        //     this.$router.push({name: 'self-registration-additional-info'})
        // }
        //
        // }
    }, // End of Component > computed
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                if (this.configData.additionalInfo == false) {
                    this.$router.push('/self-register/preview')
                } else {
                    this.$router.push({
                        name: 'self-registration-additional-info',
                    })
                }
                this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > methods
} // End of export default
</script>
